var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83711 16.7666C6.83711 18.2776 5.3056 19.5014 3.41855 19.5014C1.53151 19.5014 0 18.2776 0 16.7666C0 15.2569 1.53151 14.0317 3.41855 14.0317C5.3056 14.0317 6.83711 15.2569 6.83711 16.7666ZM19.1439 14.0317C19.1439 15.5427 17.6124 16.7666 15.7254 16.7666C13.8383 16.7666 12.3068 15.5427 12.3068 14.0317C12.3068 12.5207 13.8383 11.2969 15.7254 11.2969C17.6124 11.2969 19.1439 12.5207 19.1439 14.0317Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7763 14.0295V1.72266H19.1437V14.0295H17.7763ZM6.8369 3.09008V16.7643H5.46948V3.09008H6.8369Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46948 2.96138C5.46948 2.62238 5.59539 2.29548 5.82279 2.04407C6.05019 1.79267 6.36287 1.63469 6.70016 1.60079L17.6395 0.506854C17.8297 0.487744 18.0217 0.508702 18.2033 0.568378C18.3848 0.628054 18.5519 0.725122 18.6936 0.853321C18.8353 0.981519 18.9486 1.138 19.0261 1.31268C19.1036 1.48735 19.1437 1.67633 19.1437 1.86744V3.09128L5.46948 4.4587V2.96138Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.9a5e1e8569e9894cbd756ba6a0213f87.svg";
export { ForwardRef as ReactComponent };